import { OptionWithIdType } from '~/features/types';
import { getData } from '~/utils/service';
import { SPECIALTY_BOARD_ROUTE_NAME } from './constants';

export const SPEC_BOARD_API_CALLS = {
  get: async (props: {
    medicalBoardId: string;
    transformResponse?: (data: string) => OptionWithIdType[];
  }): Promise<OptionWithIdType[]> => {
    return await getData(SPECIALTY_BOARD_ROUTE_NAME, {
      pathParams: { medicalBoardId: props.medicalBoardId },
      transformResponse: props.transformResponse,
    });
  },
};
